module.exports = __webpack_public_path__ + "static/media/roboto-vietnamese-400-normal.a8be5b46.woff2";